 <!--承运商档案>新增>合同管理  -->
<template>
  <div id="account">
    <div class="btns">
      <el-button class="btnItems" v-if="hasPermiss('admin:collecation_account:delCollecationAccount')" @click="delBtns()">删除</el-button>
      <el-button class="btnItems" v-if="hasPermiss('admin:collecation_account:udpateCollecationAccount')" @click="modify()">编辑</el-button>
      <el-button class="btnItems" v-if="hasPermiss('admin:collecation_account:addCollecationAccount')" @click="add()">添加</el-button>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table :height="tableHeight" header-align="center" ref="mytable" @row-click="rowclick" :data="tableData" border stripe :highlight-current-row="true" @selection-change="handleSelectionChange">
        <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
        <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column fixed="right" label="合同图片" min-width="210px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="lookImgs(scope.row)">查看图片</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></paging>
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia" @diaCancelBtn="diaCancelBtn" @diaConfirmBtn="diaConfirmBtn">
      <div class="addForm">
        <el-form :model="formdata" ref="addForm" v-if="isShowDialog" :rules="rules" label-width="100px" class="dia_form">
          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="合同编号:" prop="contractNo">
                <el-input v-model="formdata.contractNo" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="起始时间:" prop="contractStartTime">
                <el-date-picker v-model="formdata.contractStartTime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="终止时间:" prop="contractEndTime">
                <el-date-picker v-model="formdata.contractEndTime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同状态:" prop="contractStatus">
                <el-select v-model="formdata.contractStatus" placeholder="请选择">
                  <el-option label="正常" value="zheng_chang:contract_status" />
                  <el-option label="已过期" value="yi_guo_qi:contract_status" />
                  <el-option label="即将过期	" value="ji_jiang_guo_qi:contract_status" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="60">
            <el-col :span="24">
              <el-form-item label="合同图片:" prop="fileIds">
                <uploadimgs @input="changeFileList" :fileNameLists="fileNameLists" :limit="9"></uploadimgs>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-top:16px;">
            <el-col :span="24">
              <el-form-item label="备注:">
                <el-input type="textarea" rows="2" v-model="formdata.remarks" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </my-dialog>
    <!-- 大图预览 -->
    <el-dialog title="查看图片" :visible.sync="bigImgsShow" width="50%" center :close-on-click-modal="false">
      <div class style="display: flex">
        <div v-for="(item, index) in srcList" :key="index">
          <el-image style="width: 180px; height: 180px; margin: 10px" :src="item" :preview-src-list="srcList"></el-image>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" size="mini" @click="bigImgsShow = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script >
import myDialog from "@/components/Dialog.vue";
import paging from "@/components/pagings.vue"; //分页组件
import uploadimgs from "@/components/upLoadImgs.vue";

export default {
  components: {
    myDialog,
    paging,
    uploadimgs,
  },
  props: {
    common: {
      type: Object,
    },
  },
  data() {
    return {
      pageGroupName: "CustomMOD_contractManagement", //  页面标识
      reportFiledsNumber: "admin_customer_contract_list", // 动态 条件、表头
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeight: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据
      myTableHeard: [], //  我的表头
      tableData: [], //  表格数据

      tabelHeadeTitle: [], //默认表头
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      sortName: "综合查询模板", //  排序名
      className: "", //  导出需要

      diaWidth: "70%",
      dialogTitle: null,
      isShowDialog: false,
      formdata: {
        contractNo: "",
        contractStartTime: "",
        contractEndTime: "",
        contractStatus: "",
        remarks: "",
      },
      rules: {
        contractNo: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        contractStartTime: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        contractEndTime: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        contractStatus: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        fileIds: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },

      srcList: [],
      bigImgsShow: false,
      fileNameLists: [],
      customerId: this.common.customerId,
      CollectionArr: [],
    };
  },
  props: {
    common: {
      type: Object,
    },
  },

  created() {
    this.initTable();
    this.GetConfDictValDownList("return_settlement_method");
  },
  watch: {
    $route(to, from) {
      let id = this.$route.query.customerId || "";
      if (to.path == "/Customers/CustomMOD/Edit" && id) {
        this.customerId = id
        this.initTable();
      }
    },
  },
  methods: {
    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },
    getData() {
      let params = {
        conditionReqs: [
          {
            conditonKey: "customerId",
            conditonVal: this.customerId,
          },
        ],
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
        number: this.reportFiledsNumber,
      };
      this.$API.runPageReport(params).then((res) => {
        if (res.data.status === "success") {
          let datas = res.data.result.datas || {};
          this.className = datas.className || "";
          this.tableData = datas.data || [];
          this.pageCount = datas.pageCount || 0;
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },
    async initTable() {
      //获取当前页面已设置表头
      await this.$API
        .getGroupFindFieldSort({
          groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        })
        .then((res) => {
          let arr = res.data.result || [];
          if (arr.length > 0) {
            if (arr[0].sortObject) {
              this.tabelHeadeTitle = JSON.parse(arr[0].sortObject);
              this.sortName = arr[0].sortName;
            }
          }
        });
      //表格 表头默认
      await this.$API
        .getReportFileds({
          number: this.reportFiledsNumber,
        })
        .then((res) => {
          let datas = res.data.result || [];
          let lists = [];
          datas.forEach((element) => {
            lists.push({
              name: element.fieldNameShow,
              field: element.fieldAlias,
              width: element.wide,
              isTotal: element.isSum,
              sort: element.sort,
              isShow: element.isShow == 0 ? false : true,
              isSort: true,
            });
          });
          this.originalTabelHeadeTitle = lists;
          if (!this.tabelHeadeTitle.length) {
            this.tabelHeadeTitle = this.originalTabelHeadeTitle;
          }
        });
      this.myTableHeard = this.tabelHeadeTitle;
      setTimeout(() => {
        this.queryBtn_ok();
      }, 0);
    },
    changeFileList(array) {
      this.fileNameLists = array;
      this.formdata.fileIds = array.map((item) => {
        return item.name;
      });
    },
    // 查看图片
    lookImgs({ contractId }) {
      this.$API.customergetContractPics({ contractId }).then((res) => {
        let filse = res.data.result || [];
        if (filse && filse.length > 0) {
          let arrs = [];
          arrs = filse.map((item) => {
            return item.fileUrl;
          });
          this.srcList = arrs;
          this.bigImgsShow = true;
        } else {
          this.$message.warning("打开失败,没有检测到图片地址");
        }
      });
    },
    // 获取字典数据--回款方式
    GetConfDictValDownList(param) {
      this.$API.getConfDictValDownList({ dictType: param }).then((res) => {
        if (res.data.status === "success") {
          this.CollectionArr = res.data.result || [];
        } else {
          this.$message.error(`${res.data.message}`);
        }
      });
    },
    handleSizeChange(val) {
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.getData();
    },
    delBtns(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              contractIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.contractIds.push(val.contractId);
            });
            this.$API.customerdelContract(delReq).then((res) => {
              if (res.data.status === "success") {
                try {
                  let num = 0;
                  let arr = this.tableConfig.tableData;
                  if (delReq.contractIds.length > 2) {
                    delReq.contractIds.map(function (v, i) {
                      num = arr.findIndex((element) => element.contractId == v);
                      arr.splice(num, 1);
                    });
                  } else {
                    num = arr.findIndex(
                      (element) => element.contractId == delReq.contractIds[0]
                    );
                    arr.splice(num, 1);
                  }
                } catch {
                  this.getData();
                }
                this.$message.success("已删除");
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    async modify(data) {
      this.fileNameLists = [];
      this.formdata = {
        contractNo: "",
        contractStartTime: "",
        contractEndTime: "",
        contractStatus: "",
        remarks: "",
      };
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        let curdatas = this.selectTableData[0];
        await this.$API
          .customergetContractPics({ contractId: curdatas.contractId })
          .then((res) => {
            let filse = res.data.result || [];
            if (filse && filse.length > 0) {
              this.fileNameLists = filse.map((item) => {
                return {
                  name: item.fileId,
                  url: item.fileUrl,
                };
              });
              curdatas.fileIds = filse.map((item) => {
                return item.fileId;
              });
            }
          });
        this.formdata = curdatas;
        this.dialogTitle = "编辑合同";
        this.isShowDialog = true;
      }
    },
    add() {
      this.fileNameLists = [];
      this.formdata = {
        contractNo: "",
        contractStartTime: "",
        contractEndTime: "",
        contractStatus: "",
        remarks: "",
      };
      this.dialogTitle = "添加合同";
      this.isShowDialog = true;
    },

    // 表格
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          let params = {
            ...this.formdata,
          };
          let { contractStartTime, contractEndTime } = params;
          params.contractStartTime = contractStartTime.includes("00:00:00")
            ? contractStartTime
            : `${contractStartTime} 00:00:00`;
          params.contractEndTime = contractEndTime.includes("23:59:59")
            ? contractEndTime
            : `${contractEndTime} 23:59:59`;
          let param = {
            customerId: this.customerId,
            ...params,
          };
          if (param.contractId && param.contractId !== null) {
            // 修改接口
            this.$API.customerupdateContract(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.getData();
              }
            });
          } else {
            // 新增接口
            this.$API.customeraddContract(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.getData();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.formdata = {
        contractNo: "",
        contractStartTime: "",
        contractEndTime: "",
        contractStatus: "",
        remarks: "",
      };
      this.isShowDialog = false;
    },

    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },
  },
};
</script>
<style scoped lang="less">
#account {
  margin: 40px 40px;
  .btns {
    flex: 1;
    .btnItems {
      border: 1px solid #606266;
      background-color: #fff;
      color: #333;
      padding: 5px 20px;
      margin-left: 10px;
      margin-bottom: 8px;
    }

    .el-button:hover {
      border: 1px solid #ef7c0a;
      color: #ef7c0a;
    }
  }
  .addForm {
    margin: 10px 40px;
  }
  .dia_form {
    .el-form-item {
      margin-bottom: 0px;
      min-width: 260px;
    }
  }
}
</style>
